// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedVendor: Object,
};

const DeleteVendor = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedVendor,
  } = props;

  const deleteVendor = () => {
    submit(selectedVendor.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteVendor} type="danger">Delete</SpButton>,
      ]}
      title="Delete Contact"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this contact?</div>
        <SpH5 className="pb-3">
          <div>{selectedVendor.name}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteVendor;
